export const getLoanPurposeParam = (lookingTo, amountOfCashOut = 0) => {
  const purpose = lookingTo === "Refinance" ? "Refinance" : "Purchase";

  if (amountOfCashOut !== 0 && lookingTo === "RefinanceAndCashOut") {
    return "CashoutRefinance";
  }

  return purpose;
};
